import { struct } from 'io-ts/Decoder';

import { Id as ImageId } from '../../../../../whole-house/image/Id';

export const Param = struct({
	imageId: ImageId,
});
